import React, { useRef, useState } from "react";
import {
  BottomText,
  BottomTitles,
  Container,
  CurrentStatus,
  GreyBar,
  IterableBottom,
  IterableSubTitle,
  IterableTitle,
  IterableTitleSlot,
  PBContainer,
  PBNumber,
  ImageHolder,
  ImageDiv,
  PlaceHolderCounter,
  IterableData,
  Warning,
  LastData,
} from "./styles";
import ProgressBar from "../../ActivedFlows/Iterable/ProgressBar";
import ExcludeModal from "../../ActivedFlows/Iterable/ExcludeModal";
import Button from "../../../components/general/Button";
import Trash from "../../../assets/icons/Trash";
import WorkersPopper from "../../ActivedFlows/Iterable/WorkersPopper";
import { debounce } from "lodash";

import { useDispatch } from "react-redux";
import { handleRemoveActivedFlow } from "../../../state/activedFlows/actions";
import { DateTime } from "luxon";

const ActiveIterable = ({
  onClick = null,
  title = "Title MIA",
  status = "Concluido", // "Concluido" or "Delayed"
  description = "Por favor entre em contato para concertos",
  startDate = null,
  endDate = null,
  client = "MIA",
  delayed = "MIA",
  concluded = "MIA",
  flowId,
  reload,
  relatedUsers,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [wPopperOpen, setWPopperOpen] = useState(false);

  const delayWPopper = debounce(() => setWPopperOpen(true), 500);
  const handleOnMouseLeaveW = () => {
    setWPopperOpen(false);
    delayWPopper.cancel();
  };

  const dispatch = useDispatch();

  const handleRemove = async () => {
    dispatch(handleRemoveActivedFlow({ flowId })).then((res) => {
      setConfirmOpen(false);
      reload();
    });
  };

  return (
    <>
      <Container onClick={onClick}>
        <IterableTitleSlot>
          <IterableTitle>{title}</IterableTitle>
          <CurrentStatus status={status}>Concluído</CurrentStatus>
          {/*status === "Delayed" ? (
            <Warning status={status}>
              *O Fluxo foi finalizado com {concluded} dias de atraso
            </Warning>
          ) : (
            <Warning status={status}>
              *O Fluxo foi finalizado com {concluded} dias de antecedencia
            </Warning>
          )*/}
        </IterableTitleSlot>
        <IterableSubTitle>{description}</IterableSubTitle>
        <GreyBar />
        <IterableBottom>
          <IterableData width={"14.5%"}>
            <BottomTitles>Data de Início</BottomTitles>
            <BottomText>
              {DateTime.fromISO(startDate).toFormat("dd/MM/yyyy")}
            </BottomText>
          </IterableData>
          <IterableData width={"14.5%"}>
            <BottomTitles>Data de Conclusão</BottomTitles>
            <BottomText status={status}>
              {DateTime.fromISO(endDate).toFormat("dd/MM/yyyy")}
            </BottomText>
          </IterableData>
          <IterableData width={"20%"}>
            <BottomTitles>Cliente</BottomTitles>
            <BottomText>{client}</BottomText>
          </IterableData>
          <IterableData width={"28.2%"}>
            <BottomTitles>Progresso</BottomTitles>

            <PBContainer>
              <ProgressBar progress={100} status={status} />
            </PBContainer>
          </IterableData>
          <LastData width={"22.8%"}>
            <ImageDiv
              onMouseLeave={handleOnMouseLeaveW}
              onMouseEnter={delayWPopper}
            >
              {relatedUsers.length > 0 && relatedUsers.length < 5
                ? relatedUsers.map((item, index) => (
                    <ImageHolder
                      key={Math.random() + index}
                      src={item.avatarURL}
                    />
                  ))
                : relatedUsers.length >= 5
                ? relatedUsers
                    .slice(0, 5)
                    .map((item, index) => (
                      <ImageHolder
                        key={Math.random() + index}
                        src={item.avatarURL}
                      />
                    ))
                : null}
              {relatedUsers.length >= 5 ? (
                <PlaceHolderCounter>
                  {"+" + (relatedUsers.length - 5)}
                </PlaceHolderCounter>
              ) : null}
              {relatedUsers.length > 0 ? (
                <WorkersPopper
                  isOpen={wPopperOpen}
                  onClose={() => setWPopperOpen(false)}
                  onConfirm={(e) => {
                    console.log(e);
                  }}
                  Workers={relatedUsers}
                />
              ) : null}
            </ImageDiv>
          </LastData>
        </IterableBottom>

        <Button
          Icon={() => <Trash />}
          onClick={(event) => {
            event.stopPropagation();
            setConfirmOpen(true);
          }}
          square
          style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            zIndex: 0,
          }}
          size="2.15rem"
          background="#FFBAAB"
          colorText="#D93333"
          activeBackground="#CB9A8F"
        />
      </Container>
      <ExcludeModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        flowName={title}
        onConfirm={handleRemove}
        tipe="Encerrado"
      />
    </>
  );
};

export default ActiveIterable;
